"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _setMixerAttendee = _interopRequireDefault(require("../../../actions/attendee/setMixerAttendee"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function mixerAttendeeJoined(_ref, _ref2) {
  var dispatch = _ref.dispatch;
  var attendeeId = _ref2.attendeeId;
  dispatch((0, _setMixerAttendee["default"])(attendeeId));
}
var _default = exports["default"] = mixerAttendeeJoined;